// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wf-select-user[data-v-555b6e5c]{width:480px;height:calc(100% - 30px);background:#fff;box-shadow:0 2px 4px rgba(0,0,0,.16);border-radius:10px 0 0 10px;position:absolute;right:0;top:0;padding:10px 10px 20px 20px}.wf-select-user .tab-content[data-v-555b6e5c]{margin-top:10px;height:calc(100% - 290px);padding-bottom:15px}.headBox[data-v-555b6e5c]{display:flex}.headBox .el-radio[data-v-555b6e5c]{margin-top:8px;margin-right:20px}", ""]);
// Exports
module.exports = exports;
